import React from 'react';
import ReactTable from 'react-table-v6';

import './Table.scss';
import './TableOverride.scss';

const Table = props => {
  const { columns, data, ...rest } = props;
  return (
    <ReactTable
      filterable
      defaultPageSize={25}
      defaultFilterMethod={(filter, row) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined
          ? String(row[id])
              .toLowerCase()
              .includes(filter.value.toLowerCase())
          : true;
      }}
      columns={columns}
      data={data}
      {...rest}
    />
  );
};

export default Table;
